import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-directivo',
  templateUrl: './card-directivo.component.html',
  styleUrls: ['./card-directivo.component.scss']
})
export class CardDirectivoComponent implements OnInit {

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  rutas(params: string) {
    this.router.navigate([params]);
  }
}
